import { tv, type VariantProps } from '@/lib/tv';

const buttonStyles = tv({
  base: [
    'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full',
    'text-sm font-medium [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0',
    'cursor-pointer transition-[background-color,transform] duration-150 ease-out',
    'focus-visible:focus-ring-brand active:scale-98 disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none',
  ],
  variants: {
    variant: {
      default:
        'bg-primary-purple-900 text-neutral-0 shadow-btn-primary hover:bg-primary-purple-800',
      secondary:
        'bg-primary-beige-200 text-neutral-900 shadow-btn-secondary hover:bg-primary-beige-300',
    },
    size: {
      default: 'h-10 px-4 py-2',
      lg: 'h-11 px-8',
    },
  },
  defaultVariants: { variant: 'default', size: 'default' },
});

type ButtonVariants = VariantProps<typeof buttonStyles>;

const buttonVariants = ({ variant, size }: ButtonVariants = {}): string =>
  buttonStyles({ variant, size });

export { buttonVariants };
